// @ts-nocheck
import React from 'react'

import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

// Styles
import '@/globals.css'
import '@assets/iconify-icons/generated-icons.css'
import 'react-perfect-scrollbar/dist/css/styles.css'

// Router
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'

import { router } from '@/routes'

// Auth
import { AuthProvider } from '@/contexts/AuthContext'

// Country
import { publicApi } from '@/libs/apiClient'
import { syncCountryFromApi } from '@/utils/country'

// MUI

// Currency / dial code come from the static country config; refresh them from
// the backend in the background without delaying the first render
syncCountryFromApi(() => publicApi.get('/api/v1/store/country').then(res => res.data?.data))

const root = ReactDOM.createRoot(document.getElementById('app-root') as HTMLElement)

root.render(
  <React.StrictMode>
    <InitColorSchemeScript attribute='data' defaultMode='light' />
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
)
